// Prompt after packs are claimed/bought — always added to Inventory.

import React from "react";

export default function PackOpenPrompt({
    packCount = 1,
    sourceLabel = "",
    onConfirm,
}) {
    const count = Math.max(1, Math.floor(Number(packCount) || 1));
    const packLabel = count === 1 ? "1 Corgi Pack" : `${count} Corgi Packs`;
    const lead = String(sourceLabel || "").trim();

    return (
        <div
            className="guideHeartDemoOverlay packOpenPrompt"
            role="dialog"
            aria-modal="true"
            aria-labelledby="packOpenPromptTitle"
        >
            <div className="guideHeartDemoOverlay__panel">
                <div
                    id="packOpenPromptTitle"
                    className="guideHeartDemoOverlay__title"
                >
                    Added to Inventory
                </div>
                <p className="guideHeartDemoOverlay__message">
                    {lead
                        ? `${lead} ${packLabel} ${
                              count === 1 ? "has" : "have"
                          } been added to your Inventory on Profile.`
                        : `${packLabel} ${
                              count === 1 ? "has" : "have"
                          } been added to your Inventory on Profile.`}
                </p>
                <div className="packOpenPrompt__actions">
                    <button
                        type="button"
                        className="homePrimaryButton guideHeartDemoOverlay__button"
                        onClick={onConfirm}
                    >
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
}
